// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"performance-settings_checkboxWrapper__239Fh","tooltipWrapper":"performance-settings_tooltipWrapper__3G7K9"};